import { toast } from "sonner";
import customFetch from "../util/config/axiosConfig";
import {
  AttenderApiResponse,
  AttenderPayload,
  AttenderResponse,
} from "../types/attenderType";

const attenderApis = {
  // post
  createAttender: async (
    studentId: number,
    payload: AttenderPayload,
  ): Promise<AttenderResponse> => {
    try {
      const response = await customFetch.post<AttenderResponse>(
        `/api/v1/attender/${studentId}`,
        payload,
      );

      if (response.data.status === 1) {
        toast.success(response.data.data || "Attender created successfully");
      } else {
        toast.error(response.data.error || "Failed to create attender");
      }

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.data ||
        "Error creating attender";

      toast.error(message);
      throw error;
    }
  },

  // PUT (Update Attender)
  updateAttender: async (
    attenderId: number,
    payload: AttenderPayload,
  ): Promise<AttenderResponse> => {
    try {
      const response = await customFetch.put<AttenderResponse>(
        `/api/v1/attender/update/${attenderId}`,
        payload,
      );

      if (response.data.status === 1) {
        toast.success(response.data.data || "Attender updated successfully");
      } else {
        toast.error(response.data.error || "Failed to update attender");
      }

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.data ||
        "Error updating attender";

      toast.error(message);
      throw error;
    }
  },

  // GET
  getAttenders: async (studentId: number): Promise<AttenderApiResponse> => {
    try {
      const response = await customFetch.get<AttenderApiResponse>(
        `/api/v1/attender/list/${studentId}`,
      );

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.error || "Failed to fetch attenders";
      toast.error(message);
      throw error;
    }
  },

  // DELETE Attender
  deleteAttender: async (attenderId: number) => {
    try {
      const response = await customFetch.delete(
        `/api/v1/attender/delete/${attenderId}`,
      );

      if (response.data.status === 1) {
        toast.success(response.data.data || "Attender deleted successfully");
      } else {
        toast.error(response.data.error || "Failed to delete attender");
      }

      return response.data;
    } catch (error: any) {
      const message =
        error?.response?.data?.error ||
        error?.response?.data?.data ||
        "Error deleting attender";

      toast.error(message);
      throw error;
    }
  },
};

export default attenderApis;
